module.exports = __webpack_public_path__ + "img/h5Home_bg.cb68019c.png";